// dashbaord
import Crypto from '../Components/Dashboard/Crypto';
import Default from '../Components/Dashboard/Default';
import Ecommerce from '../Components/Dashboard/Ecommerce';
import OnlineCourse from '../Components/Dashboard/OnlineCourse';
import Social from '../Components/Dashboard/Social';

// //widgets
import Chart from '../Components/Widgets/Chart';
import General from '../Components/Widgets/General';

// //page-layout
// import FooterLight from '../Components/PageLayout/FooterLight';

// import FooterDark from '../Components/PageLayout/FooterDark';
// //ui-kits
import Typography from '../Components/UiKits/Typography';
import Avatars from '../Components/UiKits/Avtars';
import HelperClasses from '../Components/UiKits/HelperClass';
import Grid from '../Components/UiKits/Grid';
import TagAndPills from '../Components/UiKits/TagAndPills';
import Progressbars from '../Components/UiKits/Progress';
import Modals from '../Components/UiKits/Modals';
import Alert from '../Components/UiKits/Alert';
import Popover from '../Components/UiKits/Popover';
import Tooltips from '../Components/UiKits/Tooltip';
import Spinners from '../Components/UiKits/Spinners';
import Dropdowns from '../Components/UiKits/Dropdown';
import Accordian from '../Components/UiKits/Accordian';
import TabBootstrap from '../Components/UiKits/Tabs/BootstrapTab';
import TabLine from '../Components/UiKits/Tabs/LineTab';
import Navs from '../Components/UiKits/Navs';
import Shadow from '../Components/UiKits/Shadows';
import List from '../Components/UiKits/Lists';

// //Bonus-ui
import Scrollable from '../Components/Bonus-Ui/Scrollable';
import TreeView from '../Components/Bonus-Ui/TreeView';
import BootstrapNotify from '../Components/Bonus-Ui/BootstrapNotify';
import RatingClass from '../Components/Bonus-Ui/Rating';
import Dropzones from '../Components/Bonus-Ui/Dropzones';
import Tours from '../Components/Bonus-Ui/Tour';
import SweetAlerts from '../Components/Bonus-Ui/SweetAlert';
import Carousels from '../Components/Bonus-Ui/Carousel';
import Ribbons from '../Components/Bonus-Ui/Ribbons';
import Paginations from '../Components/Bonus-Ui/Pagination';
import Steps from '../Components/Bonus-Ui/Steps';
import BreadcrumbClass from '../Components/Bonus-Ui/Breadcrumb';
import RangeSlider from '../Components/Bonus-Ui/RangeSlider';
import Imagecropper from '../Components/Bonus-Ui/ImageCropper';
import Sticky from '../Components/Bonus-Ui/Sticky';
import DragAndDrop from '../Components/Bonus-Ui/DragAndDrop';
import UploadImage from '../Components/Bonus-Ui/ImageUpload';
import BasicCards from '../Components/Bonus-Ui/Cards/BasicCards/index';
import CreativeCards from '../Components/Bonus-Ui/Cards/CreativeCards';
import TabCard from '../Components/Bonus-Ui/Cards/TabCard';
import DraggingCards from '../Components/Bonus-Ui/Cards/DragCards/index';
import Timeline1 from '../Components/Bonus-Ui/Timeline/Timeline1';
// // Icons
import WeatherIcon from '../Components/Icons/WeatherIcon';
import FeatherIcon from '../Components/Icons/FeatherIcon';
import ThemifyIcon from '../Components/Icons/ThemifyIcon';
import IcoIcon from '../Components/Icons/IcoIcon';
import FontawesomeIcon from '../Components/Icons/FontawesomeIcon';
import FlagIcon from '../Components/Icons/FlagIcon';

// // Buttons
import DefaultButton from '../Components/Buttons/Default';
import FlatButton from '../Components/Buttons/FlatBtn/index';
import EdgeButton from '../Components/Buttons/Edge/index';
import RaisedButton from '../Components/Buttons/RaisedBtn/index';
import GroupButton from '../Components/Buttons/GroupBtn/index';

// //chart
import ApexCharts from '../Components/Charts/ApexCharts';
import Chartist from '../Components/Charts/ChartistCharts';
import ChartJs from '../Components/Charts/ChartsJs';
import GoogleCharts from '../Components/Charts/GoogleCharts';

// //forms
import FormValidation from '../Components/Forms/FormControl/FormValidation';
import BaseInput from '../Components/Forms/FormControl/BaseInput';
import CheckboxandRadio from '../Components/Forms/FormControl/CheckRadio';
import InputGroups from '../Components/Forms/FormControl/InputGroups';
import MegaOption from '../Components/Forms/FormControl/MegaOption';
import Datepicker from '../Components/Forms/FormWidget/DatePicker';
import Timepicker from '../Components/Forms/FormWidget/TimepickerComponent/TimePicker';
import TypeaheadComp from '../Components/Forms/FormWidget/TypeaheadComponent/Typeahead';
import FormDefault from '../Components/Forms/FormLayout/Default';
import FormWizard from '../Components/Forms/FormLayout/FormWizard1/FormWizard1';
import BasicTables from '../Components/Tables/Reactstrap/BasicTable';

import DataTables from '../Components/Tables/DataTable';

// //Application
import Newproject from '../Components/Application/Project/Newproject';
import Project from '../Components/Application/Project/Project';
import Chat from '../Components/Application/Chat/ChatApp';
import VideoChat from '../Components/Application/Chat/VideoChat';

import Contact from '../Components/Application/Contact/ContactApp';
import Task from '../Components/Application/Task';
import TodoContain from '../Components/Application/Todo';

// //Gallary
import ImageGallery from '../Components/Gallery/ImageGallery';
import MesonryDesc from '../Components/Gallery/MesonryDesc';
import MasonryGallery from '../Components/Gallery/MesonryGallery';
import ImageWithDesc from '../Components/Gallery/ImageWithDesc';
import ImageHover from '../Components/Gallery/ImageHover';

// //Blog
import BlogDetail from '../Components/Blog/BlogDetail';
import BlogPost from '../Components/Blog/BlogPost';
import BlogSingle from '../Components/Blog/BlogSingle';

// //Pages
import SamplePage from '../Components/Pages/Sample';
// // import SearchPage from '../Components/Application/SearchResult'

// //Book mark
import BookmarksContain from '../Components/Application/BookMarks';

// //User app
import UsersCardssContain from '../Components/Application/Users/UsersCards';
import UsersEditContain from '../Components/Application/Users/UsersEdit';
import UsersProfileContain from '../Components/Application/Users/UsersProfile';

// //social app
import SocialAppContain from '../Components/Application/SocialApp';

// //calender
// import CalenderContain from '../Components/Application/Calender/Index';

// //Email
import MailInboxContain from '../Components/Application/Email/MailInbox';

// //File Manager
import FileManagerContain from '../Components/Application/FileManager';
import SearchResultContain from '../Components/Application/SearchResult';

// //E-commerce
import Products from '../Components/Application/Ecommerce/Products';
import ProductCart from '../Components/Application/Ecommerce/ProductCart';
import WishList from '../Components/Application/Ecommerce/Wishlist';
import CheckOut from '../Components/Application/Ecommerce/CheckOut';
import Invoice from '../Components/Application/Ecommerce/Invoice';
import OrderHistory from '../Components/Application/Ecommerce/OrderHistory';
import ProductPage from '../Components/Application/Ecommerce/ProductPage';
import PricingMemberShip from '../Components/Application/Ecommerce/PricingMemberShip';
import PaymentDetails from '../Components/Application/Ecommerce/PaymentDetails';
import ProductListContain from '../Components/Application/Ecommerce/ProductList';
import KanbanBoardContain from '../Components/Application/KanbanBoard';
import DraggableContain from '../Components/Application/Calender/DraggableCalender';

// //Job Search
import JobCards from '../Components/JobSearch/JobCardView';
import ListView from '../Components/JobSearch/ListView';
import JobDetails from '../Components/JobSearch/JobDetail';
import Apply from '../Components/JobSearch/Apply';

// //Learning
import LearningList from '../Components/Learning/LearningList';
import DetailCourse from '../Components/Learning/DetailCourse';

// //Map
import GoogleMaps from '../Components/Map/GoogleMap';
import PigeonMap from '../Components/Map/Pigeon Map';

// //Editor
import CkEditorContain from '../Components/Editor/CkEditor';
import MdeEDitorContain from '../Components/Editor/MDEEditor/MDEEditor';
import ACEEditorContain from '../Components/Editor/AceCodeEditor/ACECodeEditor';

import KnowledgeBaseContain from '../Components/Knowledgebase/KnowledgeBase';
import KnowledgeCategoryContain from '../Components/Knowledgebase/KnowledgeCategory';
import KnowledgeDetailContain from '../Components/Knowledgebase/KnowledgeDetails';
import SupportTickitContain from '../Components/SupportTicket';
import DateTimeContain from '../Components/Forms/FormWidget/DateandTime';
import FormDateRangepickerContain from '../Components/Forms/FormWidget/FormDateRangePicker';
import FormSelectContain from '../Components/Forms/FormWidget/FormSelect2';
import FormSwitchContain from '../Components/Forms/FormWidget/FormSwitch';
import FormTouchspinContain from '../Components/Forms/FormWidget/FormTouchspin';
import FormClipboardContain from '../Components/Forms/FormWidget/FormClipboard';
import FAQContent from '../Components/FAQ';
import Home from '../Components/Mothrift/Home';
import WithrawFund from '../Components/Mothrift/WithrawFund';
import Notifications from '../Components/Mothrift/Notifications';
import EditProfile from '../Components/Mothrift/AccountSettings/EditProfile';
import EditPayment from '../Components/Mothrift/AccountSettings/EditPayment';
import Savings from '../Components/Mothrift/Savings';
import EarnInterest from '../Components/Mothrift/EarnInterest';
import TransactionHistory from '../Components/Mothrift/TransactionHistory';
import Security from '../Components/Mothrift/AccountSettings/Security';
import BuyAirtime from '../Components/Mothrift/BuyAirtime';

const MothriftRoutes = [
  { path: `${process.env.PUBLIC_URL}/mothrift/home`, Component: <Home /> },
  { path: `${process.env.PUBLIC_URL}/mothrift/termed-savings`, Component: <Savings /> },
  { path: `${process.env.PUBLIC_URL}/mothrift/interest-earned`, Component: <EarnInterest /> },
  { path: `${process.env.PUBLIC_URL}/mothrift/transaction-history`, Component: <TransactionHistory /> },
  { path: `${process.env.PUBLIC_URL}/mothrift/withdraw-money`, Component: <WithrawFund /> },
  { path: `${process.env.PUBLIC_URL}/mothrift/buy-airtime`, Component: <BuyAirtime /> },
  { path: `${process.env.PUBLIC_URL}/mothrift/buy-airtime/:id`, Component: <BuyAirtime /> },
  { path: `${process.env.PUBLIC_URL}/mothrift/notifications`, Component: <Notifications /> },
  { path: `${process.env.PUBLIC_URL}/mothrift/account-settings/profile`, Component: <EditProfile /> },
  { path: `${process.env.PUBLIC_URL}/mothrift/account-settings/payment`, Component: <EditPayment /> },
  { path: `${process.env.PUBLIC_URL}/mothrift/account-settings/security`, Component: <Security /> },
];

const AllRoutes = [

  // mothrift
  { path: `${process.env.PUBLIC_URL}/mothrift/home`, Component: <Home /> },
  { path: `${process.env.PUBLIC_URL}/mothrift/termed-savings`, Component: <Savings /> },
  { path: `${process.env.PUBLIC_URL}/mothrift/interest-earned`, Component: <EarnInterest /> },
  { path: `${process.env.PUBLIC_URL}/mothrift/transaction-history`, Component: <WithrawFund /> },
  { path: `${process.env.PUBLIC_URL}/mothrift/withdraw-money`, Component: <WithrawFund /> },
  { path: `${process.env.PUBLIC_URL}/mothrift/notifications`, Component: <Notifications /> },
  { path: `${process.env.PUBLIC_URL}/mothrift/account-settings/profile`, Component: <EditProfile /> },
  { path: `${process.env.PUBLIC_URL}/mothrift/account-settings/payment`, Component: <EditPayment /> },

  //dashboard
  { path: `${process.env.PUBLIC_URL}/dashboard/default`, Component: <Default /> },
  { path: `${process.env.PUBLIC_URL}/dashboard/e-commerce`, Component: <Ecommerce /> },
  { path: `${process.env.PUBLIC_URL}/dashboard/online-course`, Component: <OnlineCourse /> },
  { path: `${process.env.PUBLIC_URL}/dashboard/crypto`, Component: <Crypto /> },
  { path: `${process.env.PUBLIC_URL}/dashboard/social`, Component: <Social /> },

  // // //widgets
  { path: `${process.env.PUBLIC_URL}/widgets/general`, Component: <General /> },
  { path: `${process.env.PUBLIC_URL}/widgets/chart`, Component: <Chart /> },

  // // //page-layout
  // { path: `${process.env.PUBLIC_URL}/page-layout/footer-light`, Component: <FooterLight /> },
  // { path: `${process.env.PUBLIC_URL}/page-layout/footer-fixed`, Component: <FooterFixed /> },
  // { path: `${process.env.PUBLIC_URL}/page-layout/footer-dark`, Component: <FooterDark /> },

  // // //ui-kits
  { path: `${process.env.PUBLIC_URL}/ui-kits/typography`, Component: <Typography /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/avatar`, Component: <Avatars /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/helper-class`, Component: <HelperClasses /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/grids`, Component: <Grid /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/tag-pills`, Component: <TagAndPills /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/progress`, Component: <Progressbars /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/modal`, Component: <Modals /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/alert`, Component: <Alert /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/popover`, Component: <Popover /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/tooltips`, Component: <Tooltips /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/spinner`, Component: <Spinners /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/dropdown`, Component: <Dropdowns /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/accordion`, Component: <Accordian /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/tabs/bootstrap`, Component: <TabBootstrap /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/tabs/line`, Component: <TabLine /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/navs`, Component: <Navs /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/shadow`, Component: <Shadow /> },
  { path: `${process.env.PUBLIC_URL}/ui-kits/list`, Component: <List /> },

  // // //Bonus Ui
  { path: `${process.env.PUBLIC_URL}/bonus-ui/scrollable`, Component: <Scrollable /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/tree-view`, Component: <TreeView /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/bootstrap-notify`, Component: <BootstrapNotify /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/rating`, Component: <RatingClass /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/dropzone`, Component: <Dropzones /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/tour`, Component: <Tours /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/sweet-alert`, Component: <SweetAlerts /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/carousel`, Component: <Carousels /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/ribbons`, Component: <Ribbons /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/pagination`, Component: <Paginations /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/steps`, Component: <Steps /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/breadcrumb`, Component: <BreadcrumbClass /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/rangeslider`, Component: <RangeSlider /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/imagecropper`, Component: <Imagecropper /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/stickynotes`, Component: <Sticky /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/drag_and_drop`, Component: <DragAndDrop /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/image-upload`, Component: <UploadImage /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/card/basiccards`, Component: <BasicCards /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/card/creativecards`, Component: <CreativeCards /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/card/tabcard`, Component: <TabCard /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/card/draggingcards`, Component: <DraggingCards /> },
  { path: `${process.env.PUBLIC_URL}/bonus-ui/timelines/timeline1`, Component: <Timeline1 /> },

  // // //Icons
  { path: `${process.env.PUBLIC_URL}/icons/flag_icons`, Component: <FlagIcon /> },
  { path: `${process.env.PUBLIC_URL}/icons/fontawesome_icon`, Component: <FontawesomeIcon /> },
  { path: `${process.env.PUBLIC_URL}/icons/ico_icon`, Component: <IcoIcon /> },
  { path: `${process.env.PUBLIC_URL}/icons/themify_icons`, Component: <ThemifyIcon /> },
  { path: `${process.env.PUBLIC_URL}/icons/feather_icons`, Component: <FeatherIcon /> },
  { path: `${process.env.PUBLIC_URL}/icons/weather_icons`, Component: <WeatherIcon /> },

  // // //Buttons
  { path: `${process.env.PUBLIC_URL}/buttons/simplebutton`, Component: <DefaultButton /> },
  { path: `${process.env.PUBLIC_URL}/buttons/flat`, Component: <FlatButton /> },
  { path: `${process.env.PUBLIC_URL}/buttons/edge`, Component: <EdgeButton /> },
  { path: `${process.env.PUBLIC_URL}/buttons/raised`, Component: <RaisedButton /> },
  { path: `${process.env.PUBLIC_URL}/buttons/group`, Component: <GroupButton /> },

  // // //Charts
  { path: `${process.env.PUBLIC_URL}/charts/apex`, Component: <ApexCharts /> },
  { path: `${process.env.PUBLIC_URL}/charts/chartist`, Component: <Chartist /> },
  { path: `${process.env.PUBLIC_URL}/charts/chartJs`, Component: <ChartJs /> },
  { path: `${process.env.PUBLIC_URL}/charts/google`, Component: <GoogleCharts /> },

  // // // Forms
  { path: `${process.env.PUBLIC_URL}/forms/controls/validation`, Component: <FormValidation /> },
  { path: `${process.env.PUBLIC_URL}/forms/controls/input`, Component: <BaseInput /> },
  { path: `${process.env.PUBLIC_URL}/forms/controls/radio-checkbox`, Component: <CheckboxandRadio /> },
  { path: `${process.env.PUBLIC_URL}/forms/controls/group`, Component: <InputGroups /> },
  { path: `${process.env.PUBLIC_URL}/forms/controls/megaoption`, Component: <MegaOption /> },
  { path: `${process.env.PUBLIC_URL}/forms/widget/datepicker`, Component: <Datepicker /> },
  { path: `${process.env.PUBLIC_URL}/forms/widget/timepicker`, Component: <Timepicker /> },
  { path: `${process.env.PUBLIC_URL}/forms/widget/typeahead`, Component: <TypeaheadComp /> },
  { path: `${process.env.PUBLIC_URL}/forms/widget/datetimepicker`, Component: <DateTimeContain /> },
  { path: `${process.env.PUBLIC_URL}/forms/widget/rangepicker`, Component: <FormDateRangepickerContain /> },
  { path: `${process.env.PUBLIC_URL}/forms/widget/select2`, Component: <FormSelectContain /> },
  { path: `${process.env.PUBLIC_URL}/forms/widget/switch`, Component: <FormSwitchContain /> },
  { path: `${process.env.PUBLIC_URL}/forms/widget/touchspin`, Component: <FormTouchspinContain /> },
  { path: `${process.env.PUBLIC_URL}/forms/widget/clipboard`, Component: <FormClipboardContain /> },

  { path: `${process.env.PUBLIC_URL}/forms/layout/formDefault`, Component: <FormDefault /> },
  { path: `${process.env.PUBLIC_URL}/forms/layout/formWizard`, Component: <FormWizard /> },

  // //Tables
  { path: `${process.env.PUBLIC_URL}/table/reactstraptable/basictable`, Component: <BasicTables /> },
  { path: `${process.env.PUBLIC_URL}/table/datatable`, Component: <DataTables /> },

  // //Applicatiion
  { path: `${process.env.PUBLIC_URL}/app/project/project-list`, Component: <Project /> },
  { path: `${process.env.PUBLIC_URL}/app/project/new-project`, Component: <Newproject /> },
  { path: `${process.env.PUBLIC_URL}/app/chat-app/chats`, Component: <Chat /> },
  { path: `${process.env.PUBLIC_URL}/app/chat-app/chat-video-app`, Component: <VideoChat /> },
  { path: `${process.env.PUBLIC_URL}/app/contact-app/contacts`, Component: <Contact /> },

  { path: `${process.env.PUBLIC_URL}/app/task`, Component: <Task /> },
  { path: `${process.env.PUBLIC_URL}/app/bookmark`, Component: <BookmarksContain /> },
  { path: `${process.env.PUBLIC_URL}/app/todo-app/todo`, Component: <TodoContain /> },

  { path: `${process.env.PUBLIC_URL}/app/users/profile`, Component: <UsersProfileContain /> },
  { path: `${process.env.PUBLIC_URL}/app/users/edit`, Component: <UsersEditContain /> },
  { path: `${process.env.PUBLIC_URL}/app/users/cards`, Component: <UsersCardssContain /> },
  { path: `${process.env.PUBLIC_URL}/app/social-app`, Component: <SocialAppContain /> },

  { path: `${process.env.PUBLIC_URL}/app/calendar/draggable-calendar`, Component: <DraggableContain /> },

  { path: `${process.env.PUBLIC_URL}/app/email-app`, Component: <MailInboxContain /> },
  { path: `${process.env.PUBLIC_URL}/app/file-manager`, Component: <FileManagerContain /> },
  { path: `${process.env.PUBLIC_URL}/app/search`, Component: <SearchResultContain /> },
  { path: `${process.env.PUBLIC_URL}/app/ecommerce/product`, Component: <Products /> },
  { path: `${process.env.PUBLIC_URL}/app/ecommerce/product-page/:id`, Component: <ProductPage /> },
  { path: `${process.env.PUBLIC_URL}/app/ecommerce/payment-details`, Component: <PaymentDetails /> },
  { path: `${process.env.PUBLIC_URL}/app/ecommerce/orderhistory`, Component: <OrderHistory /> },
  { path: `${process.env.PUBLIC_URL}/app/ecommerce/pricing`, Component: <PricingMemberShip /> },
  { path: `${process.env.PUBLIC_URL}/app/ecommerce/invoice`, Component: <Invoice /> },
  { path: `${process.env.PUBLIC_URL}/app/ecommerce/cart`, Component: <ProductCart /> },
  { path: `${process.env.PUBLIC_URL}/app/ecommerce/wishlist`, Component: <WishList /> },
  { path: `${process.env.PUBLIC_URL}/app/ecommerce/checkout`, Component: <CheckOut /> },
  { path: `${process.env.PUBLIC_URL}/app/ecommerce/product-list`, Component: <ProductListContain /> },
  { path: `${process.env.PUBLIC_URL}/app/kanban-board`, Component: <KanbanBoardContain /> },

  // //Gallery
  { path: `${process.env.PUBLIC_URL}/app/gallery/grids`, Component: <ImageGallery /> },
  { path: `${process.env.PUBLIC_URL}/app/gallery/griddesc`, Component: <ImageWithDesc /> },
  { path: `${process.env.PUBLIC_URL}/app/gallery/masonrys`, Component: <MasonryGallery /> },
  { path: `${process.env.PUBLIC_URL}/app/gallery/masonrydesc`, Component: <MesonryDesc /> },
  { path: `${process.env.PUBLIC_URL}/app/gallery/hover_effect`, Component: <ImageHover /> },

  // //page
  { path: `${process.env.PUBLIC_URL}/pages/sample-page`, Component: <SamplePage /> },

  // //Blog
  { path: `${process.env.PUBLIC_URL}/app/blog/blogdetails`, Component: <BlogDetail /> },
  { path: `${process.env.PUBLIC_URL}/app/blog/blogsingle`, Component: <BlogSingle /> },
  { path: `${process.env.PUBLIC_URL}/app/blog/blogpost`, Component: <BlogPost /> },

  // //Job Search
  { path: `${process.env.PUBLIC_URL}/app/jobsearch/cardview`, Component: <JobCards /> },
  { path: `${process.env.PUBLIC_URL}/app/jobsearch/joblist`, Component: <ListView /> },
  { path: `${process.env.PUBLIC_URL}/app/jobsearch/jobdetail`, Component: <JobDetails /> },
  { path: `${process.env.PUBLIC_URL}/app/jobsearch/jobapply`, Component: <Apply /> },

  // //Learning
  { path: `${process.env.PUBLIC_URL}/app/learning/learninglist`, Component: <LearningList /> },
  { path: `${process.env.PUBLIC_URL}/app/learning/learningdetail`, Component: <DetailCourse /> },

  // //Map
  { path: `${process.env.PUBLIC_URL}/app/map/googlemap`, Component: <GoogleMaps /> },
  { path: `${process.env.PUBLIC_URL}/app/map/pigeonmap`, Component: <PigeonMap /> },

  // //Editor
  { path: `${process.env.PUBLIC_URL}/editor/ckeditor`, Component: <CkEditorContain /> },
  { path: `${process.env.PUBLIC_URL}/editor/mdeeditor`, Component: <MdeEDitorContain /> },
  { path: `${process.env.PUBLIC_URL}/editor/aceeditor`, Component: <ACEEditorContain /> },

  // //Knowledge
  { path: `${process.env.PUBLIC_URL}/app/knowledgebase`, Component: <KnowledgeBaseContain /> },
  { path: `${process.env.PUBLIC_URL}/app/knowledgebase-category`, Component: <KnowledgeCategoryContain /> },
  { path: `${process.env.PUBLIC_URL}/app/knowledgebase-detail`, Component: <KnowledgeDetailContain /> },

  // //Support Ticket
  { path: `${process.env.PUBLIC_URL}/app/supportticket`, Component: <SupportTickitContain /> },

  // //Faq
  { path: `${process.env.PUBLIC_URL}/app/faq`, Component: <FAQContent /> },
];

const isLocalhost = window.location.hostname == 'localhost';
// export const routes = isLocalhost ? AllRoutes : MothriftRoutes;
export const routes = MothriftRoutes;
